var TypeOf =
/** @class */
function () {
  function TypeOf() {}

  TypeOf.types = function (data) {
    return Object.prototype.toString.call(data);
  };

  TypeOf.isNumber = function (data) {
    return TypeOf.types(data) === "[object Number]";
  };

  TypeOf.isString = function (data) {
    return TypeOf.types(data) === "[object String]";
  };

  TypeOf.isObject = function (data) {
    return TypeOf.types(data) === "[object Object]";
  };

  TypeOf.isEmptyObject = function (data) {
    return TypeOf.isObject(data) && JSON.stringify(data) === "{}";
  };

  TypeOf.isArray = function (data) {
    return TypeOf.types(data) === "[object Array]";
  };

  TypeOf.isEmptyArray = function (data) {
    return TypeOf.isArray(data) && JSON.stringify(data) === "[]";
  };

  TypeOf.isUndefined = function (data) {
    return TypeOf.types(data) === "[object Undefined]";
  };

  TypeOf.isNull = function (data) {
    return TypeOf.types(data) === "[object Null]";
  };

  TypeOf.isNil = function (data) {
    return TypeOf.isUndefined(data) || TypeOf.isNull(data);
  };

  TypeOf.isEmpty = function (data) {
    return TypeOf.isNil(data) || TypeOf.isEmptyArray(data) || TypeOf.isEmptyObject(data) || data === "";
  };

  TypeOf.isFunction = function (data) {
    return TypeOf.types(data) === "[object Function]";
  };

  return TypeOf;
}();

export { TypeOf };